<template>
  <v-row no-gutters dense>
    <v-col
      cols="12"
      v-if="paynowPaymentRecovery
        || airwallexInvoiceRecovery
        || airwallexInvoiceRecoveryUnavailable"
    >
      <v-alert
        :type="paynowPaymentRecovery
          ? (paynowInvoiceCanRequestPaymentMethodSwitch ? 'info' : 'warning')
          : airwallexInvoiceRecoveryUnavailable
          || (airwallexInvoiceRecovery
            && airwallexInvoiceRecovery.recoverable === false)
          ? 'error' : 'info'"
        dense
        outlined
      >
        <div>{{ paynowPaymentRecovery
          ? paynowInvoiceRecoveryMessage
          : airwallexInvoiceRecoveryMessage }}</div>
        <v-btn
          v-if="paynowInvoiceRecoveryRefreshRecommended
            || airwallexInvoiceRecoveryRefreshRecommended"
          class="mt-2"
          color="primary"
          small
          :loading="airwallexInvoiceRecoveryLoading"
          :disabled="loading || airwallexSavedCardsBusy
            || airwallexInvoiceCancellationInProgress"
          @click="refreshAirwallexInvoiceStatus()"
        >
          Refresh payment status
        </v-btn>
      </v-alert>
    </v-col>
    <v-col cols="12" v-if="invoice.invoiceStatusId === 4">
      <v-card
        outlined
      >
        <v-card-text>
          <v-row no-gutters dense>
            <v-col cols="12">
              <div class="subtitle-2 mb-1">Payment Method</div>
              <v-radio-group
                :value="paymentMethod"
                :disabled="loading || airwallexInvoiceRecoveryLockRequired"
                @change="selectAirwallexInvoicePaymentMethod"
                row
                class="mt-0"
              >
                <v-radio
                  v-for="method in paymentMethods"
                  :key="method.value"
                  :label="method.text"
                  :value="method.value"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-form
            ref="form"
            v-if="!airwallexInvoiceRecoveryUnavailable"
          >
            <v-row no-gutters dense>
              <v-col cols="2" >
                <h5 v-if="invoice.tax > 0">
                  Inclusive of GST @9%: ${{ invoice.tax }}
                </h5>
                <h3>Total: {{ amount }}</h3>
              </v-col>
            </v-row>
            <v-row no-gutters dense v-if="paymentMethod == 1">
              <v-col cols="12">
                <br>
                <v-divider></v-divider>
                <br>
              </v-col>
              <v-col cols="12" md="4" v-if="$store.state.brand == 'cldy'">
                <h2>Bank Transfer</h2>
                <p>Payee: CLDY.com Pte Ltd<br>
                Name of Bank: DBS BANK<br>
                Account No.: 0720348400<br>
                Bank Code: 7171<br>
                Branch Code: 072</p>
              </v-col>
              <v-col cols="12" md="4" v-else>
                <h2>Bank Transfer</h2>
                <p>Payee: GoCloudEasy Pte Ltd<br>
                  Name of Bank: DBS BANK<br>
                  Account No.: 0109065458<br>
                  Bank Code: 7171<br>
                  Branch Code: 001</p>
              </v-col>
              <v-col cols="12" md="4" v-if="$store.state.brand == 'cldy'">
                  <h2>Cheque Payment</h2>
                  <p>Payable to: CLDY.com Pte Ltd<br>
                    Notes:<br>
                    Write invoice number at the back of the cheque<br>
                    Drop into DBS Quick Cheque Deposit box</p>
              </v-col>
              <v-col cols="12" md="4" v-else>
                <h2>Cheque Payment</h2>
                <p>Payable to: Gocloudeasy Pte Ltd<br>
                  Notes:<br>
                  Write invoice number at the back of the cheque<br>
                  Drop into DBS Quick Cheque Deposit box</p>
              </v-col>
              <v-col cols="12" md="4" v-if="$store.state.brand == 'cldy'">
                <h2>PayNow</h2>
                <p>UEN No.: 202107287N<br>
                  Company Name: CLDY.com Pte Ltd</p>
                <div>
                  <img alt="paynow image" :src="paynowImage">
                </div>
              </v-col>
              <v-col cols="12" md="4" v-else>
                <h2>PayNow</h2>
                <p>UEN No.: 202022399N<br>
                  Company Name: GoCloudEasy Pte Ltd</p>
              </v-col>
            </v-row>
            <v-row no-gutters dense v-if="paymentMethod == 1">
              <v-col cols="2" >
                <v-text-field label="Bank"
                              :rules="[rules.required]"
                              v-model="bank"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field label="Reference No"
                              :rules="[rules.required]"
                              v-model="referenceNo"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field label="Transfer Datetime"
                              :rules="[rules.required]"
                              v-model="transferDatetime"
                              @click.prevent="openDatetimePicker($event)"
                              :readonly="true"
                ></v-text-field>
                <datetime
                  class="datetime-picker"
                  ref="datetimePicker"
                  type="datetime"
                  v-model="pickerTransferDatetime"
                  :hour-step="1"
                  :minute-step="5"
                  format="yyyy-MM-dd HH:mm:ss"
                  auto
                ></datetime>
              </v-col>
            </v-row>
            <div v-if="paymentMethod == 3">
              <v-radio-group v-model="stripePaymentMode">
                <v-radio value="useSavedCard" v-if="hasSavedCard && !airwallexWalletSelected">
                  <template v-slot:label>
                    <div>Use saved card</div>
                  </template>
                </v-radio>
                <v-row no-gutters dense>
                  <v-col cols="6">
                    <stripe-saved-cards
                      :card.sync="savedCard"
                      :hasCard.sync="hasSavedCard"
                      v-on:remove-card="hasSavedCard = false"
                    ></stripe-saved-cards>
                  </v-col>
                </v-row>
                <v-row v-if="hasSavedCard && !airwallexWalletSelected"></v-row>
                <v-radio value="useNewCard" v-if="hasSavedCard && !airwallexWalletSelected">
                  <template v-slot:label>
                    <div>Use new card</div>
                  </template>
                </v-radio>
                <v-row
                  v-show="!hasSavedCard || stripePaymentMode === 'useNewCard'"
                  no-gutters dense
                >
                  <v-col cols="12" md="6">
                    <stripe-payment
                      :amount="amount"
                      :card.sync="creditCard"
                      :invalid.sync="creditCardInvalid"
                    ></stripe-payment>
                  </v-col>
                </v-row>
                <v-row
                  v-show="!hasSavedCard || stripePaymentMode === 'useNewCard'"
                  no-gutters dense
                >
                  <v-col cols="12">
                    <v-checkbox
                      v-if="$store.state.brand === 'cldy'"
                      label="Save as default card? I authorise CLDY.com PTE. LTD. to send
                    instructions to the financial institution that issued my card to take payments
                    from my card account in accordance with the terms of my agreement with you."
                      v-model="saveAsDefaultCard"
                    ></v-checkbox>
                    <v-checkbox
                      v-else
                      label="Save as default card? I authorise GOCLOUDEASY PTE. LTD. to send
                    instructions to the financial institution that issued my card to take payments
                    from my card account in accordance with the terms of my agreement with you."
                      v-model="saveAsDefaultCard"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-radio-group>
            </div>
            <div v-if="paymentMethod == 4">
              <v-radio-group v-model="paypalPaymentMode">
                <v-radio value="useSavedCard" v-if="hasSavedCard && !airwallexWalletSelected">
                  <template v-slot:label>
                    <div>Use saved card</div>
                  </template>
                </v-radio>
                <v-row no-gutters dense>
                  <v-col cols="6">
                    <paypal-saved-cards
                      :card.sync="savedCard"
                      :hasCard.sync="hasSavedCard"
                      v-on:remove-card="hasSavedCard = false"
                    ></paypal-saved-cards>
                  </v-col>
                </v-row>
                <v-row v-if="hasSavedCard && !airwallexWalletSelected"></v-row>
                <v-radio value="useNewCard" v-if="hasSavedCard && !airwallexWalletSelected">
                  <template v-slot:label>
                    <div>Use new card</div>
                  </template>
                </v-radio>
                <v-row
                  v-show="!hasSavedCard || paypalPaymentMode === 'useNewCard'"
                  no-gutters dense
                >
                  <v-col cols="12" md="6">
                    <paypal-payment
                      :amount="amount"
                      :orderid="paypalOrderId"
                      :saveasdefaultcard="saveAsDefaultCard"
                      @interface="getChildInterface"
                      @reset="reset"
                      :card.sync="creditCard"
                      :invalid.sync="creditCardInvalid"
                    ></paypal-payment>
                  </v-col>
                </v-row>
                <v-row
                  v-show="!hasSavedCard || paypalPaymentMode === 'useNewCard'"
                  no-gutters dense
                >
                  <v-col cols="12">
                    <v-checkbox
                      v-if="$store.state.brand === 'cldy'"
                      label="Save as default card? I authorise CLDY.com PTE. LTD. to send
                    instructions to the financial institution that issued my card to take payments
                    from my card account in accordance with the terms of my agreement with you."
                      v-model="saveAsDefaultCard"
                    ></v-checkbox>
                    <v-checkbox
                      v-else
                      label="Save as default card? I authorise GOCLOUDEASY PTE. LTD. to send
                    instructions to the financial institution that issued my card to take payments
                    from my card account in accordance with the terms of my agreement with you."
                      v-model="saveAsDefaultCard"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-radio-group>
            </div>
            <div v-if="paymentMethod == 5">
              <v-row no-gutters dense>
                <v-col cols="8"></v-col>
                <v-col cols="4">
                    <paypal-express
                      v-if="!($store.state.brand === 'cldy'
                        && (!tosAccepted || !tosAuditSucceeded || tosAuditPromise))"
                      :amount="amount"
                      :invoiceid="invoiceId"
                      @interface="getChildInterface2"
                      v-on:reset="reset()"
                    ></paypal-express>
                </v-col>
              </v-row>
            </div>
            <div v-if="paymentMethod == 6">
              <p v-if="!paynowPaymentRecovery || paynowInvoiceCanRetry || paynowReady">
                Note: Please open up your banking app and prepare to Scan and Pay.
                This QR code is dynamically generated and payment has to be completed
                within 1 hour after the QR code is generated.
              </p>
              <div v-if="paynowReady">
                <img :src="paynowImage2" width="160">
              </div>
            </div>
            <div v-if="[7, 8].includes(paymentMethod)">
              <v-radio-group
                :value="airwallexPaymentMode"
                :disabled="airwallexInvoicePaymentSourceLocked"
                @change="selectAirwallexInvoicePaymentSource"
              >
                <v-radio value="useSavedCard" v-if="hasSavedCard && !airwallexWalletSelected">
                  <template v-slot:label>
                    <div>Use saved card</div>
                  </template>
                </v-radio>
                <v-radio value="useNewCard" v-if="hasSavedCard && !airwallexWalletSelected">
                  <template v-slot:label>
                    <div>Use new card</div>
                  </template>
                </v-radio>
              </v-radio-group>
              <v-row no-gutters dense>
                <v-col cols="6">
                  <airwallex-saved-cards v-if="!airwallexWalletSelected"
                    ref="airwallexSavedCards"
                    :card.sync="savedCard"
                    :hasCard.sync="hasSavedCard"
                    :busy.sync="airwallexSavedCardsBusy"
                    :disabled="airwallexInvoiceSavedCardControlsLocked"
                    v-on:remove-card="hasSavedCard = false"
                  ></airwallex-saved-cards>
                </v-col>
              </v-row>
              <v-row
                v-show="airwallexWalletSelected || !hasSavedCard
                  || airwallexPaymentMode === 'useNewCard'"
                no-gutters dense
              >
                <v-col cols="12" md="6">
                  <airwallex-payment
                    :allow-apple-pay="applePayEnabled"
                      :apple-pay="airwallexWalletSelected"
                      :key="paymentMethod"
                    @apple-pay-selected="selectAirwallexApplePay"
                    :amount="amount"
                    :invalid.sync="creditCardInvalid"
                    :disabled="airwallexInvoiceCardInputLocked"
                    @interface="getAirwallexInterface"
                  ></airwallex-payment>
                </v-col>
              </v-row>
              <v-row
                v-if="airwallexWalletSelected || !hasSavedCard
                  || airwallexPaymentMode === 'useNewCard'"
                no-gutters
                dense
              >
                <v-col cols="12">
                  <v-checkbox
                    v-if="$store.state.brand === 'cldy'"
                    label="Save as default card? I authorise CLDY.com PTE. LTD. to send
                  instructions to the financial institution that issued my card to take payments
                  from my card account in accordance with the terms of my agreement with you."
                    v-model="saveAsDefaultCard"
                    :disabled="airwallexInvoiceSavedCardControlsLocked || airwallexWalletSelected"
                  ></v-checkbox>
                  <v-checkbox
                    v-else
                    label="Save as default card? I authorise GOCLOUDEASY PTE. LTD. to send
                  instructions to the financial institution that issued my card to take payments
                  from my card account in accordance with the terms of my agreement with you."
                    v-model="saveAsDefaultCard"
                    :disabled="airwallexInvoiceSavedCardControlsLocked || airwallexWalletSelected"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </div>
          </v-form>
          <v-row no-gutters dense v-if="$store.state.brand === 'cldy'">
            <v-col cols="12">
              <div class="d-flex justify-end">
                <v-checkbox
                  v-model="tosAccepted"
                  hide-details
                  class="mb-2"
                  :disabled="loading || !!tosAuditPromise
                    || airwallexInvoiceRecoveryLoading
                    || airwallexInvoiceCancellationInProgress
                    || airwallexInvoiceRecoveryUnavailable"
                  @change="recordTosDecision"
                >
                  <template v-slot:label>
                    <div>
                      I have read, understood, and accept the
                      <a
                        href="https://www.cldy.com/sg/terms-of-service/"
                        target="_blank"
                        rel="noopener"
                        @click.stop
                      >Terms of Service</a>.
                    </div>
                  </template>
                </v-checkbox>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters dense v-if="paymentMethod !== 5">
            <v-col cols="12" class="text-right">
              <v-btn color="primary"
                     v-if="paymentMethod === 4"
                     :loading="loading"
                     :disabled="airwallexInvoiceRecoveryLoading
                       || airwallexInvoiceCancellationInProgress
                       || airwallexInvoiceRecoveryUnavailable
                       || ($store.state.brand === 'cldy'
                         && (!tosAccepted || !tosAuditSucceeded || !!tosAuditPromise))"
                     @click="submit">
                  {{ airwallexWalletSelected
                    ? 'Continue with Apple Pay' : 'Make Payment (Visa/Master)' }}
                </v-btn>
              <v-btn color="primary"
                     v-else-if="paymentMethod === 6"
                     :loading="loading"
                     :disabled="airwallexInvoiceRecoveryLoading
                       || airwallexInvoiceCancellationInProgress
                       || airwallexInvoiceRecoveryUnavailable
                       || (!!paynowPaymentRecovery && !paynowInvoiceCanRetry)
                       || ($store.state.brand === 'cldy'
                         && (!tosAccepted || !tosAuditSucceeded || !!tosAuditPromise))"
                     @click="submit">{{ paynowInvoiceButtonLabel }}</v-btn>
              <v-btn
                v-else-if="[7, 8].includes(paymentMethod)"
                color="primary"
                :loading="loading"
                :disabled="airwallexSavedCardsBusy
                  || airwallexInvoiceRecoveryLoading
                  || airwallexInvoiceCancellationInProgress
                  || airwallexInvoiceRecoveryUnavailable
                  || (airwallexInvoiceRecovery
                    && airwallexInvoiceRecovery.recoverable === false)
                  || ($store.state.brand === 'cldy'
                    && (!tosAccepted || !tosAuditSucceeded || !!tosAuditPromise))"
                @click="submit"
              >{{ airwallexInvoiceButtonLabel }}</v-btn>
              <v-btn
                v-else
                color="primary"
                :loading="loading"
                :disabled="airwallexInvoiceRecoveryLoading
                  || airwallexInvoiceCancellationInProgress
                  || airwallexInvoiceRecoveryUnavailable
                  || ($store.state.brand === 'cldy'
                    && (!tosAccepted || !tosAuditSucceeded || !!tosAuditPromise))"
                @click="submit">Submit</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col>
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">
              Description
            </th>
            <th class="text-left">
              Discount
            </th>
            <th class="text-left">
              Amount
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="item in items"
            :key="item.id"
          >
            <td><pre>{{ item.invoiceLineDescription }}</pre></td>
            <td>${{ item.discount }}</td>
            <td>${{ item.subtotal }}</td>
          </tr>
          <tr v-if="invoice.discount > 0">
            <td colspan="3" class="text-right">Discount: ${{ invoice.discount }}</td>
          </tr>
          <tr v-if="invoice.tax > 0">
            <td colspan="3" class="text-right">Add GST @9%: ${{ invoice.tax }}</td>
          </tr>
          <tr>
            <td colspan="3" class="text-right">Total: ${{ invoice.total }}</td>
          </tr>
          <tr>
            <td colspan="3" class="text-right">
              <v-chip :color="invoiceStatusColor[invoice.invoiceStatusId]">
                {{ invoiceStatus[invoice.invoiceStatusId] }}
              </v-chip>
            </td>
          </tr>
          <tr v-if="invoice.invoiceStatusId === 1">
            <td colspan="3" class="text-right">
              <h5>{{ invoice.creditTransactions[0] }}</h5>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
  </v-row>
</template>

<script>
import { DateTime } from 'luxon';
import airwallexWallet from '../../../mixins/airwallex-wallet';
import {
  StripePayment, StripeSavedCards, PaypalPayment, PaypalSavedCards, PaypalExpress,
  AirwallexPayment, AirwallexSavedCards,
} from '../../components/payment_modules';
import {
  creditCardPaymentMethodLabel,
  isAirwallexPaymentPending,
  saveAirwallexCardConsent,
  toCreditCardPaymentMessage,
} from '../../../plugins/airwallex-payment';
import { recordTosDecision as auditTosDecision } from '../../../plugins/tos-audit';
import airwallexInvoiceRecovery from '../../../mixins/airwallex-invoice-recovery';

export default {
  name: 'Detail',
  mixins: [airwallexWallet, airwallexInvoiceRecovery],
  components: {
    StripeSavedCards,
    StripePayment,
    PaypalSavedCards,
    PaypalPayment,
    PaypalExpress,
    AirwallexPayment,
    AirwallexSavedCards,
  },
  data() {
    return {
      invoiceId: '',
      paypalOrderId: '',
      bank: '',
      referenceNo: '',
      transferDatetime: null,
      pickerTransferDatetime: null,
      paymentMethod: '',
      paymentMethods: [],
      amount: '',
      loading: false,
      saveAsDefaultCard: false,
      creditCardInvalid: null,
      creditCard: null,
      savedCard: null,
      hasSavedCard: false,
      airwallexSavedCardsBusy: false,
      stripePaymentMode: 'useNewCard',
      paypalPaymentMode: 'useNewCard',
      airwallexPaymentMode: 'useNewCard',
      tosAccepted: false,
      tosAuditPromise: null,
      tosAuditSucceeded: true,
      rules: {
        required: (value) => !!value || 'This field is required.',
      },
      items: [],
      invoice: {
        invoiceStatusId: '',
        discount: 0,
      },
      invoiceStatus: {
        1: 'Paid',
        2: 'Pending',
        3: 'Rejected',
        4: 'Waiting Payment',
      },
      invoiceStatusColor: {
        1: 'success',
        2: 'warning',
        3: 'error',
        4: 'warning',
      },
      firstInvoice: false,
      gtagObj: {},
      paynowReady: 0,
      paynowImage2: '#',
      paymentId: null,
      paynowImage: '#',
    };
  },
  computed: {
    airwallexInvoicePaymentSourceLocked() {
      return this.loading
        || this.airwallexSavedCardsBusy
        || this.airwallexInvoiceRecoveryLoading
        || this.airwallexInvoiceCancellationInProgress
        || this.airwallexInvoiceRecoveryUnavailable
        || (
          !!this.airwallexInvoiceRecovery
          && !this.airwallexInvoiceCanRequestPaymentMethodSwitch
        );
    },
    airwallexInvoiceSavedCardControlsLocked() {
      return this.loading
        || this.airwallexSavedCardsBusy
        || this.airwallexInvoiceRecoveryLoading
        || this.airwallexInvoiceCancellationInProgress
        || this.airwallexInvoiceRecoveryUnavailable
        || !!this.airwallexInvoiceRecovery;
    },
    airwallexInvoiceCardInputLocked() {
      const recovery = this.airwallexInvoiceRecovery;
      const retryingNewCard = recovery
        && recovery.recoverable === true
        && recovery.action === 'authorize'
        && recovery.mode === 'new';

      return this.loading
        || this.airwallexSavedCardsBusy
        || this.airwallexInvoiceRecoveryLoading
        || this.airwallexInvoiceCancellationInProgress
        || this.airwallexInvoiceRecoveryUnavailable
        || (!!recovery && !retryingNewCard);
    },
  },
  created() {
    this.invoiceId = this.$route.params.id;

    this.$api.get('partner/default-payment-method').then((response) => {
      if (this.airwallexInvoiceRecovery) {
        this.$set(this, 'paymentMethod', Number((this.airwallexInvoiceRecovery || {}).payment_type_id) || 7);
        return;
      }

      // Do not let a late initialization response overwrite a method the
      // customer selected after a guarded Airwallex cancellation.
      if (this.paymentMethod !== '' && this.paymentMethod !== null) {
        return;
      }

      this.$set(this, 'paymentMethod', response.data);
      if (this.paymentMethod === 4) {
        this.creditCardInvalid = false;
      }
    });

    this.$api.get(`partner/has-no-invoice?invoice_id=${this.invoiceId}`)
      .then((response) => {
        this.$set(this, 'firstInvoice', response.data.has_no_invoice);
      });

    this.refreshAirwallexInvoiceStatus();
    this.transferDatetime = DateTime.local().toFormat('yyyy-MM-dd HH:mm:ss');
    this.pickerTransferDatetime = DateTime.local().toISO();
    this.$api.get('partner/payment-methods').then((response) => {
      if (this.$store.state.brand === 'paypal_prod' || this.$store.state.brand === 'cldy') {
        response.data.push({
          id: 5,
          text: 'PAYPAL',
          type_name: 'PAYPAL',
          value: 5,
        });
      }
      const paymentMethods = this.filterWalletPaymentMethods(response.data).map((method) => ({
        ...method,
        text: creditCardPaymentMethodLabel(method),
      }));

      this.$set(this, 'paymentMethods', paymentMethods);
    });
  },
  methods: {
    airwallexInvoiceDetailEndpoint() {
      return `partner/tax-invoice/${this.$route.params.id}/detail`;
    },
    airwallexInvoiceCancellationEndpoint() {
      return 'partner/payment/invoice-recovery/cancel';
    },
    airwallexInvoiceCancellationPayload(recovery) {
      if (Number(recovery.payment_type_id) === 6) {
        return {
          invoice_id: this.$route.params.id,
          payment_id: recovery.payment_id,
        };
      }

      return {
        invoice_id: this.$route.params.id,
        payment_intent_id: recovery.payment_intent_id,
      };
    },
    paynowInvoiceStatusEndpoint(paymentId) {
      return `partner/payment/${paymentId}/check-paynow-status`;
    },
    paynowInvoiceStatusPayload() {
      return {
        invoice_id: this.$route.params.id,
      };
    },
    onPaynowInvoicePaymentSucceeded() {
      if (this.firstInvoice && this.$store.state.brand === 'cldy') {
        window.gtag('event', 'purchase', this.gtagObj);
      }

      this.$store.dispatch('addAlert', {
        id: Date.now(),
        type: 'success',
        message: 'Your payment is submitted successfully.',
      });
      setTimeout(() => {
        this.$router.push({
          name: 'Retail.TaxInvoice',
          params: {
            brand: this.$store.state.brand,
            id: this.$route.params.id,
            first: false,
          },
        });
      }, 500);
    },
    airwallexInvoiceRecoveryModes() {
      return ['new', 'saved'];
    },
    onAirwallexInvoiceRecoveryApplied(recovery) {
      this.airwallexPaymentMode = recovery.mode === 'saved'
        ? 'useSavedCard'
        : 'useNewCard';
      this.saveAsDefaultCard = false;
    },
    async selectAirwallexInvoicePaymentSource(paymentMode) {
      if (paymentMode === this.airwallexPaymentMode) {
        return true;
      }

      const recovery = this.airwallexInvoiceRecovery;

      if (!recovery) {
        this.airwallexPaymentMode = paymentMode;
        return true;
      }

      const recoveryPaymentMode = recovery.mode === 'saved'
        ? 'useSavedCard'
        : 'useNewCard';

      this.airwallexPaymentMode = recoveryPaymentMode;

      if (!this.airwallexInvoiceCanRequestPaymentMethodSwitch) {
        return false;
      }

      const released = await this
        .cancelAirwallexInvoiceRecoveryForPaymentSwitch(recovery);

      if (!released || this.airwallexInvoiceRecoveryDestroyed) {
        const retainedRecovery = this.airwallexInvoiceRecovery || recovery;

        this.airwallexPaymentMode = retainedRecovery.mode === 'saved'
          ? 'useSavedCard'
          : 'useNewCard';
        return false;
      }

      this.airwallexPaymentMode = paymentMode;
      this.saveAsDefaultCard = false;
      return true;
    },
    onAirwallexInvoiceDetailSynced(detail) {
      this.syncAirwallexInvoicePresentation(detail);
    },
    getChildInterface(childInterface) {
      this.$options.childInterface = childInterface;
    },
    getChildInterface2(childInterface) {
      this.$options.childInterface2 = childInterface;
    },
    getAirwallexInterface(childInterface) {
      this.$options.airwallexInterface = childInterface;
    },
    async saveNewAirwallexCardAsDefault() {
      await saveAirwallexCardConsent(
        this.$api,
        this.$options.airwallexInterface,
      );
      const savedCardResponse = await this.$api.get(
        'partner/payment/get-saved-cards',
        { suppressErrorAlert: true },
      );
      const savedAirwallexCard = savedCardResponse.data;

      if (!savedAirwallexCard || Number(savedAirwallexCard.payment_type_id) !== 7) {
        throw new Error('The saved credit card could not be loaded.');
      }

      this.$set(this, 'savedCard', savedAirwallexCard);
      this.$set(this, 'hasSavedCard', true);
      this.$set(this, 'airwallexPaymentMode', 'useSavedCard');

      if (this.$refs.airwallexSavedCards) {
        this.$refs.airwallexSavedCards.applySavedCard(savedAirwallexCard);
      }
    },
    recordTosDecision(checked) {
      this.tosAuditSucceeded = false;
      const auditRequest = auditTosDecision({
        api: this.$api,
        store: this.$store,
        checked,
        context: 'invoice_payment',
        invoiceId: this.$route.params.id,
      }).then(() => {
        if (this.tosAuditPromise === auditRequest) {
          this.tosAuditSucceeded = true;
        }
        return true;
      }).catch(() => false).finally(() => {
        if (this.tosAuditPromise === auditRequest) {
          this.tosAuditPromise = null;
        }
      });
      this.tosAuditPromise = auditRequest;
    },
    async waitForTosAudit() {
      let pendingTosAudit = this.tosAuditPromise;
      while (pendingTosAudit) {
        // eslint-disable-next-line no-await-in-loop
        await pendingTosAudit;
        pendingTosAudit = this.tosAuditPromise;
      }
      return this.tosAuditSucceeded
        && !(this.$store.state.brand === 'cldy' && !this.tosAccepted);
    },
    async submit() {
      if (this.loading
        || this.airwallexSavedCardsBusy
        || this.airwallexInvoiceRecoveryLoading
        || this.airwallexInvoiceCancellationInProgress
        || this.airwallexInvoiceRecoveryUnavailable
      ) {
        return;
      }

      if (this.$store.state.brand === 'cldy' && !this.tosAccepted) {
        return;
      }

      this.loading = true;

      if (!(await this.waitForTosAudit())) {
        this.loading = false;
        return;
      }

      if (!this.$refs.form.validate()) {
        this.loading = false;
        return;
      }

      const airwallexRecovery = this.airwallexInvoiceRecovery;

      if ([7, 8].includes(this.paymentMethod)
        && (!this.hasSavedCard || this.airwallexPaymentMode === 'useNewCard')
        && this.saveAsDefaultCard
        && !this.airwallexWalletSelected
        && !airwallexRecovery
      ) {
        if (this.creditCardInvalid) {
          this.loading = false;
          return;
        }

        try {
          await this.saveNewAirwallexCardAsDefault();
        } catch (error) {
          const message = error.response
            ? (error.response.data.message || error.response.data)
            : error.message;
          const customerMessage = toCreditCardPaymentMessage(message);

          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: `The card could not be saved. ${
              customerMessage || 'Please retry again.'
            }`,
          });
          this.loading = false;
          return;
        }
      }

      // Saving in-flow changes both the selected mode and savedCard. Derive
      // this only after that flow completes so the invoice uses the verified
      // consent instead of trying to charge the now-reset card element again.
      const airwallexUsingSavedCard = this.paymentMethod === 7
        && (
          airwallexRecovery
            ? airwallexRecovery.mode === 'saved'
            : this.hasSavedCard && this.airwallexPaymentMode === 'useSavedCard'
        );
      const usingSavedCard = (
        this.hasSavedCard
        && this.paymentMethod === 3
        && this.stripePaymentMode === 'useSavedCard'
      ) || airwallexUsingSavedCard;

      if ((this.paymentMethod === 3 || [7, 8].includes(this.paymentMethod))
        && !usingSavedCard
        && this.creditCardInvalid
        && !([7, 8].includes(this.paymentMethod)
          && airwallexRecovery
          && airwallexRecovery.payment_intent_id)
      ) {
        this.loading = false;
        return;
      }

      if (this.paymentMethod === 1) {
        this.$api.post('partner/payment/invoice', {
          payment_type_id: this.paymentMethod,
          bank: this.bank,
          reference_no: this.referenceNo,
          transfer_datetime: this.transferDatetime,
          amount: this.amount,
          invoice_id: this.$route.params.id,
        })
          .then(() => {
            if (this.firstInvoice && this.$store.state.brand === 'cldy') {
              window.gtag('event', 'purchase', this.gtagObj);
            }

            const successMessage = 'Your payment is submitted successfully. Admin will review and confirm the payment.';
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'success',
              message: successMessage,
            });

            setTimeout(() => {
              this.$router.push({
                name: 'Retail.TaxInvoice',
                params: {
                  brand: this.$store.state.brand,
                  id: this.$route.params.id,
                  first: false,
                },
              });
            }, 500);
          })
          .finally(() => {
            this.loading = false;
          });
      }

      if (this.paymentMethod === 3) {
        if (this.hasSavedCard && this.stripePaymentMode === 'useSavedCard') {
          this.submitInvoiceWithSavedStripeCard();
        } else {
          this.$api.post('partner/payment/invoice', {
            payment_type_id: this.paymentMethod,
            amount: this.amount,
            save_as_default_card: this.saveAsDefaultCard,
            invoice_id: this.$route.params.id,
          })
            .then((response) => {
              const stripePaymentObj = {
                payment_method: {
                  card: this.creditCard,
                },
              };

              if (this.saveAsDefaultCard) {
                stripePaymentObj.setup_future_usage = 'off_session';
              }

              window.stripeClient.confirmCardPayment(response.data.client_secret, stripePaymentObj)
                .then(async (result) => {
                  if (result.error) {
                    await this.$store.dispatch('addAlert', {
                      id: Date.now(),
                      type: 'error',
                      message: result.error,
                    });
                  } else if (result.paymentIntent.status === 'requires_capture') {
                    await this.$api.post('partner/payment/invoice', {
                      payment_type_id: this.paymentMethod,
                      capture: 1,
                      id: result.paymentIntent.id,
                      invoice_id: this.$route.params.id,
                    })
                      .then(() => {
                        const successMessage = 'Your payment is submitted successfully.';
                        this.$store.dispatch('addAlert', {
                          id: Date.now(),
                          type: 'success',
                          message: successMessage,
                        });
                        this.reset();
                      });
                  }
                })
                .finally(() => {
                  this.loading = false;
                });
            });
        }
      }

      if (this.paymentMethod === 4) {
        if (this.hasSavedCard && this.paypalPaymentMode === 'useSavedCard') {
          this.submitInvoiceWithSavedPaypalCard();
        } else {
          this.$api.post('partner/payment/invoice', {
            payment_type_id: this.paymentMethod,
            amount: this.amount,
            save_as_default_card: this.saveAsDefaultCard,
            invoice_id: this.$route.params.id,
          })
            .then((response) => {
              this.$set(this, 'paypalOrderId', response.data.order_id);
              this.$nextTick(() => {
                this.$options.childInterface.checkout()
                  .then((payload) => {
                    if (payload.liabilityShift !== 'NO'
                      && payload.authenticationStatus
                      && payload.authenticationStatus !== 'YES') {
                      this.$store.dispatch('addAlert', {
                        id: Date.now(),
                        type: 'error',
                        message: '3D Secure Authentication fails. Please retry again.',
                      });
                      this.loading = false;
                      return;
                    }

                    if (payload.liabilityShift === 'NO'
                      && payload.liabilityShifted === false
                      && payload.authenticationStatus
                      && payload.authenticationStatus === 'NO') {
                      this.$store.dispatch('addAlert', {
                        id: Date.now(),
                        type: 'error',
                        message: 'You have exited 3D Secure Authentication. Please retry again.',
                      });
                      this.loading = false;
                      return;
                    }

                    this.$api.post('partner/payment/invoice', {
                      payment_type_id: this.paymentMethod,
                      confirm: 1,
                      capture: 1,
                      id: payload.orderId,
                      amount: this.amount,
                      save_as_default_card: this.saveAsDefaultCard,
                      invoice_id: this.$route.params.id,
                    })
                      .then(() => {
                        this.$store.dispatch('addAlert', {
                          id: Date.now(),
                          type: 'success',
                          message: 'Your payment is submitted successfully.',
                        });
                        this.reset();
                      });
                  })
                  .catch((error) => {
                    if (error.message.indexOf('semantically incorrect') > 0
                      || error.message.indexOf('not well-formed') > 0) {
                      this.$store.dispatch('addAlert', {
                        id: Date.now(),
                        type: 'error',
                        message: 'We are sorry, the transaction failed. Please check the card information or try with another card.',
                      });
                    } else {
                      this.$store.dispatch('addAlert', {
                        id: Date.now(),
                        type: 'error',
                        message: `An error occurred ${error.message}. Please retry again.`,
                      });
                    }
                    this.loading = false;
                  })
                  .finally(() => {
                    this.loading = false;
                  });
              });
            });
        }
      }

      if ([7, 8].includes(this.paymentMethod)
        && airwallexRecovery
        && airwallexRecovery.recoverable === false
      ) {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'error',
          message: this.airwallexInvoiceRecoveryRequiresAuthentication
            ? 'Sign in as the invoice owner to continue the saved-card payment.'
            : 'The active credit card payment requires reconciliation. Please contact support.',
        });
        this.loading = false;
        return;
      }

      if ([7, 8].includes(this.paymentMethod)
        && airwallexRecovery
        && !airwallexRecovery.mode
      ) {
        if (!airwallexRecovery.payment_intent_id) {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: 'The active credit card payment requires reconciliation. Please contact support.',
          });
          this.loading = false;
        } else {
          const capturePayment = () => this.$api.post('partner/payment/invoice', {
            payment_type_id: Number(this.paymentMethod),
            capture: 1,
            id: airwallexRecovery.payment_intent_id,
            invoice_id: this.$route.params.id,
          });

          this.pollAirwallexInvoicePayment(capturePayment)
            .then((response) => {
              if (!response) {
                return;
              }

              if (isAirwallexPaymentPending(response)) {
                this.resetAirwallexRetryConsent();
                this.$store.dispatch('addAlert', {
                  id: Date.now(),
                  type: 'info',
                  message: 'Your card payment is still processing. This invoice has not been marked as paid yet.',
                });
                return;
              }

              this.airwallexInvoiceRecovery = null;
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'success',
                message: 'Your payment is submitted successfully.',
              });
              this.reset();
            })
            .catch((error) => this.handleAirwallexInvoiceError(error))
            .finally(() => {
              this.loading = false;
            });
        }
      } else if ([7, 8].includes(this.paymentMethod) && airwallexUsingSavedCard) {
        // The saved card shown under Airwallex may live on another module
        // (PayPal/Stripe are hidden once Airwallex is active); charge it
        // through its own module.
        if (!airwallexRecovery && this.savedCard.payment_type_id === 4) {
          this.submitInvoiceWithSavedPaypalCard();
        } else if (!airwallexRecovery && this.savedCard.payment_type_id === 3) {
          this.submitInvoiceWithSavedStripeCard();
        } else {
          const paymentCardId = airwallexRecovery
            ? airwallexRecovery.payment_card_id
            : this.savedCard.id;

          if (!paymentCardId) {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'error',
              message: 'The saved credit card is no longer available. Please contact support.',
            });
            this.loading = false;
            return;
          }

          this.rememberAirwallexInvoiceRecovery({
            mode: 'saved',
            paymentCardId,
            paymentIntentId: airwallexRecovery
              && airwallexRecovery.payment_intent_id,
          });

          const submitSavedPayment = () => this.$api.post(
            'partner/payment/invoice/use-saved-card',
            {
              payment_type_id: Number(this.paymentMethod),
              amount: this.amount,
              payment_card_id: paymentCardId,
              invoice_id: this.$route.params.id,
            },
          );

          submitSavedPayment()
            .then((response) => {
              const paymentIntentId = this
                .resolveAirwallexInvoicePaymentIntentId(response);

              if (paymentIntentId) {
                this.rememberAirwallexInvoiceRecovery({
                  mode: 'saved',
                  paymentCardId,
                  paymentIntentId,
                });
              }

              if (!isAirwallexPaymentPending(response)) {
                return response;
              }

              return this.pollAirwallexInvoicePayment(
                submitSavedPayment,
                response,
              );
            })
            .then((response) => {
              if (!response) {
                return;
              }

              if (isAirwallexPaymentPending(response)) {
                this.resetAirwallexRetryConsent();
                this.$store.dispatch('addAlert', {
                  id: Date.now(),
                  type: 'info',
                  message: 'Your card payment is still processing. This invoice has not been marked as paid yet.',
                });
                return;
              }

              if (this.firstInvoice && this.$store.state.brand === 'cldy') {
                window.gtag('event', 'purchase', this.gtagObj);
              }

              this.airwallexInvoiceRecovery = null;
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'success',
                message: 'Your payment is submitted successfully.',
              });
              this.reset();
            })
            .catch((error) => this.handleAirwallexInvoiceError(error))
            .finally(() => {
              this.loading = false;
            });
        }
      } else if ([7, 8].includes(this.paymentMethod)) {
        this.rememberAirwallexInvoiceRecovery({
          mode: 'new',
          paymentIntentId: airwallexRecovery
            && airwallexRecovery.payment_intent_id,
        });

        this.$api.post('partner/payment/invoice', {
          payment_type_id: Number(this.paymentMethod),
          amount: this.amount,
          invoice_id: this.$route.params.id,
        })
          .then((response) => {
            const paymentIntentId = this
              .resolveAirwallexInvoicePaymentIntentId(response);

            if (!paymentIntentId) {
              throw new Error('The credit card processor did not return active payment details.');
            }

            this.rememberAirwallexInvoiceRecovery({
              mode: 'new',
              paymentIntentId,
            });

            const capturePayment = () => this.$api.post('partner/payment/invoice', {
              payment_type_id: Number(this.paymentMethod),
              capture: 1,
              id: paymentIntentId,
              invoice_id: this.$route.params.id,
            });
            const waitForCapture = () => this.pollAirwallexInvoicePayment(
              capturePayment,
              isAirwallexPaymentPending(response) ? response : null,
            );

            if (isAirwallexPaymentPending(response)) {
              return waitForCapture();
            }

            if (this.creditCardInvalid) {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'info',
                message: 'Re-enter the card details, then select Resume credit card payment.',
              });
              return null;
            }

            if (!response.data.client_secret || !this.$options.airwallexInterface) {
              throw new Error('The credit card payment form is not ready.');
            }

            return this.$options.airwallexInterface.confirmIntent(
              paymentIntentId,
              response.data.client_secret,
            ).then(waitForCapture);
          })
          .then((response) => {
            if (!response) {
              return;
            }

            if (isAirwallexPaymentPending(response)) {
              this.resetAirwallexRetryConsent();
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'info',
                message: 'Your card payment is still processing. This invoice has not been marked as paid yet.',
              });
              return;
            }

            if (this.firstInvoice && this.$store.state.brand === 'cldy') {
              window.gtag('event', 'purchase', this.gtagObj);
            }

            this.airwallexInvoiceRecovery = null;
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'success',
              message: 'Your payment is submitted successfully.',
            });
            this.reset();
          })
          .catch((error) => this.handleAirwallexInvoiceError(error))
          .finally(() => {
            this.loading = false;
          });
      }

      if (this.paymentMethod === 6) {
        this.$api.post('partner/payment/invoice', {
          payment_type_id: this.paymentMethod,
          amount: this.amount,
          invoice_id: this.$route.params.id,
        })
          .then((response) => {
            this.rememberPaynowInvoicePaymentResponse(response.data);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    submitInvoiceWithSavedStripeCard() {
      this.$api.post('partner/payment/invoice/use-saved-card', {
        payment_type_id: 3,
        amount: this.amount,
        payment_card_id: this.savedCard.id,
        invoice_id: this.$route.params.id,
      })
        .then((response) => {
          const stripePaymentObj = {};

          window.stripeClient.confirmCardPayment(response.data.client_secret, stripePaymentObj)
            .then(async (result) => {
              if (result.error) {
                await this.$store.dispatch('addAlert', {
                  id: Date.now(),
                  type: 'error',
                  message: result.error,
                });
              } else if (result.paymentIntent.status === 'requires_capture') {
                await this.$api.post('partner/payment/invoice', {
                  payment_type_id: 3,
                  capture: 1,
                  id: result.paymentIntent.id,
                  invoice_id: this.$route.params.id,
                })
                  .then(() => {
                    const successMessage = 'Your payment is submitted successfully.';
                    this.$store.dispatch('addAlert', {
                      id: Date.now(),
                      type: 'success',
                      message: successMessage,
                    });
                    this.reset();
                  });
              }
            })
            .finally(() => {
              this.loading = false;
            });
        });
    },
    submitInvoiceWithSavedPaypalCard() {
      this.$api.post('partner/payment/invoice/use-saved-card', {
        payment_type_id: 4,
        amount: this.amount,
        payment_card_id: this.savedCard.id,
        invoice_id: this.$route.params.id,
      })
        .then((response) => {
          this.$set(this, 'paypalOrderId', response.data.order_id);
          this.$nextTick(() => {
            this.$api.post('partner/payment/invoice', {
              payment_card_id: this.savedCard.id,
              payment_type_id: 4,
              confirm: 1,
              capture: 1,
              id: this.paypalOrderId,
              amount: this.amount,
              invoice_id: this.$route.params.id,
            })
              .then(() => {
                if (this.firstInvoice && this.$store.state.brand === 'cldy') {
                  window.gtag('event', 'purchase', this.gtagObj);
                }

                this.$store.dispatch('addAlert', {
                  id: Date.now(),
                  type: 'success',
                  message: 'Your payment is submitted successfully.',
                });

                setTimeout(() => {
                  this.$router.push({
                    name: 'Retail.TaxInvoice',
                    params: {
                      brand: this.$store.state.brand,
                      id: this.$route.params.id,
                      first: false,
                    },
                  });
                }, 500);
              })
              .catch((error) => {
                this.$store.dispatch('addAlert', {
                  id: Date.now(),
                  type: 'error',
                  message: `An error occurred ${error.message}. Please retry again.`,
                });
                this.loading = false;
              })
              .finally(() => {
                this.loading = false;
              });
          });
        });
    },
    reset() {
      const { brand } = this.$store.state;
      this.$router
        .push({ name: 'Retail.TaxInvoiceList', params: { brand } })
        .catch(() => {
        });
    },
    openDatetimePicker(event) {
      this.$refs.datetimePicker.open(event);
    },
  },
  watch: {
    pickerTransferDatetime: {
      handler(newPickerTransferDatetime) {
        if (newPickerTransferDatetime !== null) {
          this.transferDatetime = DateTime.fromISO(newPickerTransferDatetime).toFormat('yyyy-MM-dd HH:mm:ss');
        }
      },
      deep: true,
    },
    hasSavedCard: {
      handler(hasSavedCard) {
        if (this.airwallexWalletSelected) {
          this.airwallexPaymentMode = 'useNewCard';
          this.saveAsDefaultCard = false;
          return;
        }
        if (this.airwallexInvoiceRecovery) {
          const recoveryUsesSavedCard = this.airwallexInvoiceRecovery.mode === 'saved';
          this.airwallexPaymentMode = recoveryUsesSavedCard
            ? 'useSavedCard'
            : 'useNewCard';
          this.saveAsDefaultCard = false;
          return;
        }

        if (this.loading) {
          return;
        }

        if (hasSavedCard) {
          this.stripePaymentMode = 'useSavedCard';
          this.paypalPaymentMode = 'useSavedCard';
          this.airwallexPaymentMode = 'useSavedCard';
          this.saveAsDefaultCard = false;
        } else {
          this.stripePaymentMode = 'useNewCard';
          this.paypalPaymentMode = 'useNewCard';
          this.airwallexPaymentMode = 'useNewCard';
          this.saveAsDefaultCard = true;
        }
      },
    },
  },
};
</script>
<style>
  .datetime-picker input {
    visibility: hidden !important;
  }
</style>
